<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-keyboard-off`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M44 3a2 2 0 012 2v24a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h40zM30.298 36.908a.997.997 0 01.662 1.74l-6.347 5.643a.996.996 0 01-1.323 0l-6.347-5.642a.996.996 0 01.662-1.741h12.693zM6 7h36v20H6V7zm25 12a1 1 0 011 1v2a1 1 0 01-1 1H17a1 1 0 01-1-1v-2a1 1 0 011-1h14zm6-7a1 1 0 00-1-1H12a1 1 0 00-1 1v2a1 1 0 001 1h24a1 1 0 001-1v-2z"/></svg>
</template>
<script>

export default {
  name: 'IconKeyboardOff',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
